import { render, staticRenderFns } from "./Insure.vue?vue&type=template&id=a6651318&scoped=true&"
import script from "./Insure.vue?vue&type=script&lang=js&"
export * from "./Insure.vue?vue&type=script&lang=js&"
import style0 from "./Insure.vue?vue&type=style&index=0&id=a6651318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6651318",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6651318')) {
      api.createRecord('a6651318', component.options)
    } else {
      api.reload('a6651318', component.options)
    }
    module.hot.accept("./Insure.vue?vue&type=template&id=a6651318&scoped=true&", function () {
      api.rerender('a6651318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/Insure.vue"
export default component.exports